const CLASSES = {
    active: 'active',
    pageStepOne: 'cc-customizePage--step-one',
    pageStepTwo: 'cc-customizePage--step-two',
};

export default CLASSES;
